<template>
  <Modal
    name="ADD_HOST_MODAL"
    :title="$t('appointment.adminActions.addHost.action')"
    actions
  >
    <template v-slot:body>
      <v-progress-linear
        class="mt-5 mb-7"
        v-show="isLoading"
        indeterminate
        rounded
      />

      <div v-show="!isLoading">
        <v-form ref="appointmentFormAddHost" lazy-validation>
          <HostSelect
            v-model="host"
            :rules="[rules.required]"
            :dense="false"
            :notBlockedForAppointmentId="appointment.id"
          />
        </v-form>
      </div>
    </template>
    <template v-slot:actions>
       <v-btn
        @click="closeAllModals"
        :disabled="isLoading || isAddingHost"
        elevation="0"
        class="mr-5"
        large
        text
      >
        {{ $t('appointment.buttons.cancel') }}
      </v-btn>

      <v-btn
        @click="validate"
        :loading="isLoading || isAddingHost"
        color="primary"
        elevation="0"
        large
      >
        {{ $t('appointment.adminActions.addHost.action') }}
      </v-btn>
    </template>
  </Modal>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from 'vuex'
import { required } from '@/util/errorHandling'
import Modal from '@/components/app/Modal'
import HostSelect from '@/components/host/HostSelect'

export default {
  name: 'AppointmentAddHost',
  components: {
    Modal,
    HostSelect
  },
  data() {
    return {
      isAddingHost: false,
      host: null,
      rules: {
        required
      },
    }
  },
  computed: {
    ...mapGetters(['appointment', 'isLoading']),
  },
  methods: {
    ...mapActions(['appointmentAddHost']),
    ...mapMutations(['closeAllModals']),

    validate() {
      if (this.$refs.appointmentFormAddHost.validate()) {
        this.isAddingHost = true

        const body = {
          appointment_id: this.appointment.id,
          host_id: this.host.id
        }

        this.appointmentAddHost(body)
          .then(() => {
            if (this.$parent?.refreshMap) this.$parent?.refreshMap()
            if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
          })
          .then(() => this.closeAllModals())
          .finally(() => this.isAddingHost = false)
      }
    },
  },
}
</script>
